import React from 'react'
import { SanitySharesTable } from '../../../../../types/generated/graphql-types'
import { sanitySharesTableToSharesTableProps } from '../../../../mapping/SharesTableMapper'
import { SharesTable } from '../../../SharesTable'

export const SharesTableSerializer = (props: SanitySharesTable): JSX.Element => (
  <SharesTable {...sanitySharesTableToSharesTableProps(props)} />
)
